import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="border-b border-black" data-testid="not-found">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 text-center">
        <div className="font-mono text-[11px] uppercase tracking-widest text-[#0047FF]">
          / 404
        </div>
        <h1 className="font-display text-6xl md:text-8xl tracking-tight mt-3">
          Page not found
        </h1>
        <p className="text-[#475569] mt-4">The link is broken or the page has moved.</p>
        <Link to="/" className="inline-block mt-6 pl-btn-primary px-6 py-3 border border-black">
          Back to PrivacyLens
        </Link>
      </div>
    </main>
  );
}
